import React, { useEffect, useRef, useState } from "react";
import { isEmpty } from 'lodash';
import { useForm } from 'react-hook-form'
import { emailPattern, signupValidation } from "../../../../Utils/ValidationUtils";
import LoaderSubmitButton from "../../../Common/LoaderSubmitButton";
import { toast } from "react-toastify";
import { isEclipseOpsTruck, showAlert, toastOptions } from "../../../../Utils/Utility";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { sendReceiptAction, sendEclipseReceiptAction } from '@mobile-dev/platform/common/redux/actions/SendReceiptActions';
import { clearError } from "@mobile-dev/platform/common/redux/actions/CommonAction";
import { injectIntl } from 'react-intl';

function EmailDialoge({ intl, open = false, id, loadId, onClose }) {

    const [show, setShow] = useState(open);
    const { register, handleSubmit, formState: { errors } } = useForm();
    const toastId = useRef(null);
    const [email, setEmail] = useState('');
    const dispatch = useDispatch();
    const emailStatus = useSelector(state => state.sendReceipt);
    const { formatMessage } = intl;
    const completedData = useSelector(state => state.completed.completedPo);
    const load = completedData.loads.find(load => load.load_id === loadId);

    useEffect(() => {
        dispatch(clearError());
    }, []);

    useEffect(() => {
        if (emailStatus?.error?.response) {

            if (!toast.isActive(toastId.current)) {
                toastOptions.autoClose = false;
                toastOptions.type = 'error';
                toastId.current = toast(emailStatus?.error?.response?.data, toastOptions);
            }
        }
        else if (emailStatus.emailStatus) {
            handleClose();
            showAlert(toast.TYPE.SUCCESS, "Receipt has been sent successfully");
        }
    }, [emailStatus]);

    const handleClose = () => {
        setShow(false);
        onClose();
    }

    const onSubmit = (data) => {
        if (isEclipseOpsTruck(load)) {
            const locData = {
                email: data.email,
                id: loadId
            }
            dispatch(sendEclipseReceiptAction(locData))

        } else {
            const request = {
                "email_csv_list": data.email,
                "load_id": loadId
            }
            dispatch(sendReceiptAction(request));
        }
    }

    if (!isEmpty(errors)) {
        if (!isEmpty(errors)) {
            Object.keys(errors).map(e => {
                signupValidation.filter(s => s.name === e).forEach(v => {
                    if (!toast.isActive(toastId.current)) {
                        toastOptions.autoClose = true;
                        toastOptions.type = 'warning';
                        toastId.current = toast(v.message, toastOptions);
                    }
                });
            });
        }
    }
    return (
        <React.Fragment>
            <Modal
                className="fade contest_input_modal"
                show={show}
                onHide={handleClose}
                backdrop='static'
                keyboard={false}
            >
                <form className="form-emailSubmission" onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Dialog className="modal-dialog-centered modal-our">

                        <Modal.Body>

                            <div className="row">
                                <div class="col-md-12">

                                    <label htmlFor="eMail" className="required">{formatMessage({ id: "app.email_address" })}</label>
                                    <input type="text" name="email" className="form-control"
                                        placeholder={`${formatMessage({ id: "app.enter" })} ${formatMessage({ id: "app.email_address" })}`} defaultValue={email}
                                        {...register("email", { required: true, pattern: emailPattern })}
                                    />


                                </div>

                            </div>
                        </Modal.Body>
                        <Modal.Footer className="border-0 justify-content-center pb-5">
                            <button type="button" className="btn btn-outline-dark" style={{ minWidth: '100px' }} onClick={handleClose}>
                                {formatMessage({ id: "app.close" })}</button>
                            <LoaderSubmitButton
                                name={formatMessage({ id: "app.submit" })}
                                className="btn btn-chartreuse"
                                loading={emailStatus.loading}

                            />
                        </Modal.Footer>
                    </Modal.Dialog>
                </form>

            </Modal>

        </React.Fragment>
    )
}

export default injectIntl(EmailDialoge);